export default __webpack_public_path__ + "static/media/movimenti.dd16b9da.less";